/**
 * Created by calhosh on 7/16/2017.
 */

import _ from 'lodash';
import {currentResource, labels} from '../../../util/utils';
import {minorErrorCodes, ToastMessageVariants} from '../../../util/uiconstants';

export default class ErrorsUtility extends Object {
	static isMinorError = (errorMessage) => {
		if (!_.isEmpty(errorMessage) && typeof errorMessage === 'string') {
			let errorCode = errorMessage.substr(0, 4);
			return minorErrorCodes.some((minorError) => parseInt(errorCode) === minorError);
		}
		return false;
	};

    static isExcludedError = (errorMessage) => {
		if (!_.isEmpty(errorMessage) && typeof errorMessage === 'object') {

            //Object Not Found errors are excluded from being shown on UI
			let isIgnoredError = errorMessage?.isObjectNotFoundError;
			return isIgnoredError && isIgnoredError === true;
		}
		return false;
	};

	static getErrorCodeValue = (errorCodes, isRBAC, isEngagementProfileRequirement, isIndependenceRequirement) => {
		let errors = [];
		/!*User = 1000 - 2000*!/;

		if (errorCodes.length > 0) {
			for (let i = 0; i < errorCodes.length; i++) {
				if (isRBAC) {
					errors.push(
						'<section><strong>' +
							errorCodes[i] +
							': ' +
							'</strong>' +
							currentResource.RbacErrors[errorCodes[i]] +
							'</section>'
					);
				} else if (isEngagementProfileRequirement) {
					errors.push(
						'<section><strong>' +
							errorCodes[i] +
							': ' +
							'</strong>' +
							currentResource.EngagementProfileRequirementErrors[errorCodes[i]] +
							'</section>'
					);
				} else if (isIndependenceRequirement) {
					errors.push(
						'<section><strong>' +
							errorCodes[i] +
							': ' +
							'</strong>' +
							currentResource.IndependenceRequirementErrors[errorCodes[i]] +
							'</section>'
					);
				} else {
					errors.push(
						'<section><strong>' +
							errorCodes[i] +
							': ' +
							'</strong>' +
							currentResource.Errors[errorCodes[i]] +
							'</section>'
					);
				}
			}
			return errors;
		} else return errorCodes;
	};

	static errorMessages = (errors) => {
		let errorCodes = [],
			errorMessages = [],
			error,
			message = '',
			errorMessage = '',
			isRBAC = false,
			isEngagementProfileRequirement = false,
			isIndependenceRequirement = false;
		try {
			if (errors && errors['RBACV2-Global'] && errors['RBACV2-Global'].length > 0) {
				isRBAC = true;
				let errorRBACV2 = errors['RBACV2-Global'];
				if (errorRBACV2[0].indexOf(' - ') > 0) {
					error = errorRBACV2[0].substr(0, errorRBACV2[0].indexOf(' -'));
				} else {
					error = JSON.parse(JSON.stringify(errorRBACV2[0]));
				}
			} else if (errors && errors.RBACV2 && errors.RBACV2.length > 0) {
				isRBAC = true;
				if (errors.RBACV2[0].indexOf(' - ') > 0) {
					error = errors.RBACV2[0].substr(0, errors.RBACV2[0].indexOf(' -'));
				} else {
					error = JSON.parse(JSON.stringify(errors.RBACV2[0]));
				}
			} else if (errors && errors.RBAC && errors.RBAC.length > 0) {
				isRBAC = true;
				if (errors.RBAC[0].indexOf(' - ') > 0) {
					error = errors.RBAC[0].substr(0, errors.RBAC[0].indexOf(' -'));
				} else {
					error = JSON.parse(JSON.stringify(errors.RBAC[0]));
				}
			} else if (errors && errors.EngagementProfileRequirement && errors.EngagementProfileRequirement.length > 0) {
				isEngagementProfileRequirement = true;
				if (errors.EngagementProfileRequirement[0].indexOf(' - ') > 0) {
					error = errors.EngagementProfileRequirement[0].substr(
						0,
						errors.EngagementProfileRequirement[0].indexOf(' -')
					);
				} else {
					error = JSON.parse(JSON.stringify(errors.EngagementProfileRequirement[0]));
				}
			} else if (errors && errors.IndependenceRequirement && errors.IndependenceRequirement.length > 0) {
				isIndependenceRequirement = true;
				if (errors.IndependenceRequirement[0].indexOf(' - ') > 0) {
					error = errors.IndependenceRequirement[0].substr(0, errors.IndependenceRequirement[0].indexOf(' -'));
				} else {
					error = JSON.parse(JSON.stringify(errors.IndependenceRequirement[0]));
				}
			} else if (errors && errors?.EngagementUserRequirement && errors.EngagementUserRequirement.length > 0) {
				if (errors.EngagementUserRequirement[0].indexOf(' - ') > 0) {
					error = errors.EngagementUserRequirement[0].substr(0, errors.EngagementUserRequirement[0].indexOf(' -'));
				} else {
					error = JSON.parse(JSON.stringify(errors.EngagementUserRequirement[0]));
				}
			} else {
				if (errors.indexOf(' - ') > 0) {
					error = errors.substr(0, errors.indexOf(' -'));
				} else {
					error = JSON.parse(JSON.stringify(errors));
				}
			}
		} catch (err) {
			message = errors;
		}

		if (error) {
			if (error.length > 0 && Array.isArray(error)) {
				error.map((error) => {
					if (error.ErrorCode) {
						errorCodes.push(error.ErrorCode);
					} else {
						errorMessages.push(error.Message);
					}
				});
			} else {
				if (error.ErrorCode) {
					errorCodes.push(error.ErrorCode);
				} else {
					errorCodes.push(Number(error));
				}
			}

			if (errorCodes.length !== 0) {
				errorMessages = ErrorsUtility.getErrorCodeValue(
					errorCodes,
					isRBAC,
					isEngagementProfileRequirement,
					isIndependenceRequirement
				);
				if (errorMessages.length > 0) {
					errorMessages.map((message) => {
						errorMessage += message;
					});
					return errorMessage;
				}
			}

			if (errorMessages.length > 0) {
				errorMessages.map((message) => {
					errorMessage += message;
				});
				return errorMessage;
			}
		} else {
			return message;
		}
	};

	static addNotification = (errors, addNotification) => {
		if ((errors && errors.length > 0 && !ErrorsUtility.isMinorError(errors) && !ErrorsUtility.isExcludedError(errors)) || errors.level) {
			let level = errors.level ? errors.level : ToastMessageVariants.Error;
			let message = errors.message ? errors.message : ErrorsUtility.errorMessages(errors);
			const autoDismissInSeconds = errors.autoDismissInSeconds
				? errors.autoDismissInSeconds
				: level !== ToastMessageVariants.Error
				? 5000
				: 0;
			addNotification(level, message, autoDismissInSeconds);
		} else {
			if (_.keys(errors).length > 0 && !ErrorsUtility.isMinorError(errors) && !ErrorsUtility.isExcludedError(errors)) {
				let level = errors.level ? errors.level : ToastMessageVariants.Error;
				let message = errors.message ? errors.message : ErrorsUtility.errorMessages(errors);
				if (message === 'Network Error') {
					message = labels.NetworkErrorMessage;
				}
				const autoDismissInSeconds = errors.autoDismissInSeconds
					? errors.autoDismissInSeconds
					: level !== ToastMessageVariants.Error
					? 5
					: 0;
				addNotification(level, message, autoDismissInSeconds);
			}
		}
	};
}
